<template>
    <div>
        <div :style="{width: (width*perRow) + 'px'}">
            <div v-for="_ in circlesNumber" class="float-start">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circle float-left" :style="{ width: width + 'px' }" viewBox="0 0 24 24" stroke-width="1.5" stroke="none" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <circle cx="12" cy="12" r="9" :fill="color"/>
                </svg>
            </div>
        </div>
        <span v-if="numberOver" :style="{color: color}" class=" float-left text-start number_over">
            {{ $t("supplierDetail.concurrency.table.data.more", numberOver) }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        color: { required: true, type: String },
        number: { required: true, type: Number },
        maxRows: { default: 3, type: Number },
        perRow: { default: 10, type: Number },
    },
    data: function () {
        return {
            numberOver: null,
            width: 12
        }
    },
    computed: {
        circlesNumber: function () {
            if (this.number <= this.maxRows * this.perRow) {
                return this.number;
            }
            else {
                var max = this.maxRows * this.perRow;
                this.numberOver = this.number - max;
                return max;
            }
        }
    }
}

</script>

<style lang="scss">
.number_over {
    font-size: 12px;
}
</style>
